import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Icon from '@components/@core/Icon';

const ViewMoreLearnPagination = ({ 
    dataCy, 
    pages, 
    onChange, 
    showing = 10, 
    current 
}) => (
    <div className="view-more-pagination p-4 mb-5 mb-md-4" data-cy={dataCy}>
        {pages > 1 && (
            <div className="more-container">
                <a className="pages dsl-b14" onClick={() => onChange(showing + 10)}>
                    <strong className="mx-2">
                        View More
                        <Icon name="fas fa-chevron-down" size={10} color="#376caf" />
                    </strong>
                </a>
            </div>
        )}
        {current === pages && (
            <p data-cy={dataCy} className="p-4 border-5 dsl-d14 text-center">
                Congratulations! <br /> This is all the courses due for this month.
            </p>
        )}
    </div>
);

ViewMoreLearnPagination.propTypes = {
    dataCy: PropTypes.string,
    pages: PropTypes.number,
    onChange: PropTypes.func,
    showing: PropTypes.number,
    current: PropTypes.number,
};

export default memo(ViewMoreLearnPagination);
